import { useEffect } from "react"
import { loadConfig } from "./service"
import { checkUnifyShop, u_getUnion } from "@/utils"



export const useInitFooter = (fun: (config: FooterModel[]) => void, unionConfig: any) => {
  const defaultConfig: FooterModel[] = [
    {
      tabIconDefualt: 'https://oss-bfd-prd.dongfangfuli.com/bfd-backend-rest/2023-03-14/8cd52cda3284407fa39822eacd8f1868/首页未选中.png',
      tabIconSelected: 'https://oss-bfd-prd.dongfangfuli.com/bfd-backend-rest/2023-03-14/e186076745ad411e9362d881d4502c1f/首页选中.png',
      tabIconShow: true,
      tabText: '首页',
      tabTextShow: true,
      tabShowType: 'image',
      tabTextColor: '',
      tabUrl: ''
    },
    {
      tabIconDefualt: 'https://oss-bfd-prd.dongfangfuli.com/bfd-backend-rest/2023-03-14/9ca7a22b006c4f718321457c33f1ea04/商城未选中.png',
      tabIconSelected: 'https://oss-bfd-prd.dongfangfuli.com/bfd-backend-rest/2023-03-14/86f359e1ad4e48678dfa58ae41a85a53/商城选中.png',
      tabIconShow: true,
      tabText: '商城',
      tabTextShow: true,
      tabShowType: 'image',
      tabTextColor: 'rgb(36, 125, 255)',
      tabUrl: 'http://localhost:1024/mall?union=df'
    },
    {
      tabIconDefualt: 'https://oss-bfd-prd.dongfangfuli.com/bfd-backend-rest/2023-03-14/dda46473d63248c7add397d94823c4cc/个人中心未选中.png',
      tabIconSelected: 'https://oss-bfd-prd.dongfangfuli.com/bfd-backend-rest/2023-03-14/77235bdc29be424ea3d224b2b813be21/个人中心选中.png',
      tabIconShow: true,
      tabText: '我的',
      tabTextShow: true,
      tabShowType: 'image',
      tabTextColor: '',
      tabUrl: ''
    }
  ]

  useEffect(() => {
    if ((!checkUnifyShop() && !u_getUnion())) {
      fun(defaultConfig)
      return
    }
    if (unionConfig) {
      fun(defaultConfig)
      // fun(unionConfig)
    }
  }, [unionConfig])

}


export interface FooterModel {
  /** 默认图标 */
  tabIconDefualt?: string
  /** 选中图标 */
  tabIconSelected?: string
  /** 图标显示 */
  tabIconShow?: boolean
  /** 文案 */
  tabText?: string
  /** 文案显示 */
  tabTextShow?: boolean
  /** 文案颜色 */
  tabTextColor?: string
  /** 跳转链接 */
  tabUrl?: string
  /** 显示模式 */
  tabShowType: 'image' | 'svg'
}